<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="knowledge-base-page">
    <!-- JUMBOTRON -->
    <!--<div class="knowledge-base-jumbotron">
      <div class="knowledge-base-jumbotron-content lg:p-32 md:p-24 sm:p-16 py-8 rounded-lg mb-base">
        <h1 class="mb-1 text-white">Dedicated Source Used on Website</h1>
        <p class="text-white">Bonbon sesame snaps lemon drops marshmallow ice cream carrot cake croissant wafer.</p>
        <vs-input placeholder="Search Topic or Keyword" v-model="knowledgeBaseSearchQuery" icon-pack="feather"
                  icon="icon-search" size="large" class="w-full no-icon-border mt-6"/>
      </div>
    </div>-->

    <!-- KNOWLEDGE BASE CARDS  -->
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 lg:w-1/4 mb-base" v-for="(item,index) in card_data" :key="index">
        <router-link :to="myLink(item)">
          <vx-card>
            <div slot="no-body" class="text-center" style="padding: 7px;">
              <img :src="item.image" alt="content-img" class="responsive card-img-top" style="height: 240px;width:auto;max-width:100%;display: inline-block;">
            </div>
            <h5 class="mb-4" style="height: 38px;overflow: hidden;">{{ trunc(item.title, 60) }}</h5>
            <p class="text-dark text-sm">{{ item.created_at }}</p>
            <p class="text-grey_ mt-2" style="height: 62px;overflow: hidden;">{{ trunc(item.sub_title, 100) }}</p>
            <div class="flex justify-between flex-wrap">
              <vs-button class="mt-6 ml-auto" color="primary">{{ $t('viewAll') }}</vs-button>
            </div>
          </vx-card>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        card_data: [],
      }
    },
    methods: {
        trunc(text, n){
            return text.substr(0,n-1)+(text.length>n?'...':'');
        },
        myLink(item) {
            return `/pages/news/${item.id}`
        }
    },
    created() {
      const thisIns = this;

      // eslint-disable-next-line no-undef
      axios.get(apiUrl+'/n?token=' + token)
          .then(function (response) {

              let data = response.data;
              if(data.code === 200){
                  thisIns.card_data = data.data;
              }else{
                  if (data.code === 401){
                      window.logout();
                  }
                  thisIns.$vs.notify({
                      title: 'Error',
                      text:  data.message,
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle'
                  });
              }

          });
    },
    components: {}
  }
</script>

<style lang="scss">
  .text-grey_ {
    color: #636363 !important
  }

  .knowledge-base-jumbotron-content {
    background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
    background-size: cover;
  }
</style>
